import { Permissions } from "../../../utils/permissions";
import "../styles/ModernSidebar.css";

const SidebarComponent = ({
  path,
  pathname,
  hidden,
  usuario,
}) => {

  return (
    <nav className="sidebar-nav"  >

      {
        path.map((p, index) => {
          if (p.dropdown && !Permissions(usuario.rol, p.path)) {
            return (
              <div className="sidebar-accordion" key={index}>
                <div className="sidebar-nav-item">
                  <button
                    className="sidebar-accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded="false"
                  >
                    <span className="sidebar-nav-icon" dangerouslySetInnerHTML={{ __html: p.icon }}></span>
                    <span className={hidden ? "d-none sidebar-text" : "sidebar-text"}>{p.title}</span>
                    <span className={hidden ? "d-none sidebar-accordion-arrow" : "sidebar-accordion-arrow"}>
                      <i className="bi bi-chevron-down"></i>
                    </span>
                  </button>
                  <div id={`collapse${index}`} className="accordion-collapse collapse">
                    <div className="sidebar-accordion-content">
                      {
                        p.nav_dropdown.map((n, nIndex) => (
                          <div className="sidebar-accordion-item" key={nIndex}>
                            <a className="sidebar-accordion-link" href={n.path}>
                              <span dangerouslySetInnerHTML={{ __html: n.icon }}></span>
                              <span className={hidden ? "d-none" : ""}>{n.title}</span>
                            </a>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            )
          }

          if(!Permissions(usuario.rol, p.path)){
            return (
              <div className="sidebar-nav-item" key={index}>
                <a
                  href={p.path}
                  className={p.path === pathname ? "sidebar-nav-link active" : "sidebar-nav-link"}
                >
                  <span className="sidebar-nav-icon" dangerouslySetInnerHTML={{ __html: p.icon }}></span>
                  <span className={hidden ? "d-none sidebar-text" : "sidebar-text"}>{p.title}</span>
                </a>
              </div>
            )
          }
        })
      }

      <div className="sidebar-divider"></div>
    </nav>
  )
}

export default SidebarComponent